// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previmgslider {
    position: absolute;
    top: 43%;
    left: 0%;
    cursor: pointer;
}

.nextimgslider {
    position: absolute;
    top: 43%;
    right: 0%;
    cursor: pointer;
}

.group_dummyimg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 25px;
    color: #fff;
    text-transform: uppercase;
}

.previmgslider circle,
.nextimgslider circle {
    fill: color-mix(in srgb, var(--brand-primary, #0877BC) 8%, #fff) !important;
    stroke: color-mix(in srgb, var(--brand-primary, #0877BC) 24%, #fff) !important;
}

.previmgslider path,
.nextimgslider path {
    fill: var(--brand-primary, #0877BC) !important;
}

.group_name {
    padding: 8px 10px 2px;
    text-align: left;
}

.group_name p {
    margin: 0;
    font-weight: 700;
    font-size: 15px;
    color: var(--text-color, #202226);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.image-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
}

.image-container img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

/* Match metrics indicator dots for groups carousel */
.groups-slider-container .indicators {
    display: flex;
    justify-content: center;
    gap: 4px;
}

.groups-slider-container .indicators .each-slideshow-indicator {
    cursor: pointer;
}

.groups-slider-container .indicators .each-slideshow-indicator::before {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #cbd5e1) !important;
}

.groups-slider-container .indicators .each-slideshow-indicator.active::before {
    background: var(--brand-primary, #0877BC) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Slider.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,2EAA2E;IAC3E,8EAA8E;AAClF;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,oDAAoD;AACxD","sourcesContent":[".previmgslider {\n    position: absolute;\n    top: 43%;\n    left: 0%;\n    cursor: pointer;\n}\n\n.nextimgslider {\n    position: absolute;\n    top: 43%;\n    right: 0%;\n    cursor: pointer;\n}\n\n.group_dummyimg {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-size: 25px;\n    color: #fff;\n    text-transform: uppercase;\n}\n\n.previmgslider circle,\n.nextimgslider circle {\n    fill: color-mix(in srgb, var(--brand-primary, #0877BC) 8%, #fff) !important;\n    stroke: color-mix(in srgb, var(--brand-primary, #0877BC) 24%, #fff) !important;\n}\n\n.previmgslider path,\n.nextimgslider path {\n    fill: var(--brand-primary, #0877BC) !important;\n}\n\n.group_name {\n    padding: 8px 10px 2px;\n    text-align: left;\n}\n\n.group_name p {\n    margin: 0;\n    font-weight: 700;\n    font-size: 15px;\n    color: var(--text-color, #202226);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.image-container {\n    position: relative;\n    width: 100%;\n    height: 0;\n    padding-bottom: 100%;\n}\n\n.image-container img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n/* Match metrics indicator dots for groups carousel */\n.groups-slider-container .indicators {\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n}\n\n.groups-slider-container .indicators .each-slideshow-indicator {\n    cursor: pointer;\n}\n\n.groups-slider-container .indicators .each-slideshow-indicator::before {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #cbd5e1) !important;\n}\n\n.groups-slider-container .indicators .each-slideshow-indicator.active::before {\n    background: var(--brand-primary, #0877BC) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
